import React, { useCallback } from "react";

import CancelIcon from '@material-ui/icons/Cancel';
import { useDropzone } from 'react-dropzone'
import GetAppIcon from '@material-ui/icons/GetApp';

function CustomDropZone(props) {

    const {
        setFile = () => { },
        id = "",
        src,
        files = [],
        accept = '.jpeg,.jpg,.png,.pdf,.xls,.doc,.docx',
        isMultiple = false,
        removeImage = () => { },
        maxSize = 52428800,
        maxFileWarn = false,
        error = '',
        noDrag = false,
        title = "",
        uploadIcon = false
    } = props

    const onDrop = useCallback((acceptedFiles = []) => {
        // Do something with the files  
        setFile(acceptedFiles)

    }, [...files])

    const { getRootProps, getInputProps } = useDropzone({ onDrop, accept: accept, maxSize, multiple: isMultiple, noDrag: noDrag })

    return (
        <div id={id}>
            <div
                className="add-file-dropzone" {...getRootProps()}>
                <input {...getInputProps()} />
                {!src.length ?
                    <>
                        {uploadIcon ? <GetAppIcon className="show-pointer" style={{ fontSize: '40px' }} /> : <img src="/images/binary.png" width="50" className="dropzone-image" alt="file" />}
                        {
                            title ? <div className="dropzone-text">{title}</div> : <div className="dropzone-text">Select & Upload firmware file<strong> (.bin)</strong> here</div>
                        }

                    </>
                    : null}

                {error && <p className="error">{error}</p>}

                {/* <h4>Drop your files here or <span>browse</span></h4> */}
                {/* <p>Supports: JPG, PNG, PDF, XLS, Docs</p> */}
                {maxFileWarn && <div>Maximum upload file size(5mb)*</div>}
                {
                    // !isMultiple ? <React.Fragment>
                    //     {

                    //         src && <div className="custom-dropzone-image-wrapper">
                    //             <div className="image-custom-dropzone-div">
                    //                 <img src={src || "/images/pdf-icon.svg"} alt="drop-image" />
                    //             </div>
                    //         </div>

                    //     }
                    // </React.Fragment>
                    //     :
                    <div className="cus-img-wrappe">
                        {
                            src && src.length ? src.map((item, index) => {
                                if (typeof item === 'string') {
                                    return (
                                        <div className="custom-dropzone-image-wrapper" key={index}>
                                            <div className="image-custom-dropzone-div d-flex1">
                                                <img src={item || ""} onClick={() => window.open(item, "_blank")} style={{ width: 60, height: 60 }} alt="files" />
                                                <CancelIcon onClick={(e) => { e.stopPropagation(); removeImage(index) }} />
                                            </div>
                                        </div>
                                    )
                                }
                                if (typeof item === 'object' && item.url) {
                                    return (
                                        <div className="custom-dropzone-image-wrapper"
                                            key={index}>
                                            <div className="image-custom-dropzone-div d-flex1">
                                                <img alt="files" src={item.url || ''} onClick={() => window.open(item.url, "_blank")} style={{ width: 36 }} />
                                                <CancelIcon onClick={(e) => { e.stopPropagation(); removeImage(index, item) }} />
                                            </div>
                                            <div>{item.name}</div>
                                        </div>
                                    )
                                }
                            })
                                :
                                null
                        }
                    </div>
                }
            </div>
        </div>
    )

}

export default CustomDropZone;
